import { createContext } from 'react';

const CanContext = createContext();
export default CanContext;
